import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { TpButtonModule } from '../tp-button/tp-button.module';
import { TpDropdownModule } from '../tp-dropdown/tp-dropdown.module';
import { TpEmailSimpleComponent } from './tp-email-simple.component';

@NgModule({
    declarations: [TpEmailSimpleComponent],
    imports: [
        CommonModule,
        FormsModule,
        MatChipsModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        TpButtonModule,
        TpDropdownModule,
        EditorModule,
    ],
    exports: [TpEmailSimpleComponent],
    providers: [
        { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' },
    ],
})
export class TpEmailSimpleModule {}
